import { AlpineComponent } from 'alpinejs';

export interface FirstLevelMenuInterface {
  // Used on desktop & mobile
  open: boolean;
  menuId: string;
  openFirstLevelMenu(): void;
  closeFirstLevelMenu(): void;
  toggleMenu(menuId: string): void;
  isFirstLevelOpen(): boolean;
  isFirstLevelMenuOpen(menuId: string): boolean;

  // Used on mobile only
  subLevelOpen: boolean;
  subLevelMenuId: string;
  openSubLevelMenu(subMenuId: string): void;
  closeSubLevelMenu(): void;
  isSubLevelOpen(): boolean;
  isSubLevelMenuOpen(subMenuId: string): boolean;
}

const FirstLevelMenu = (
  initial: boolean = false,
): AlpineComponent<FirstLevelMenuInterface> => ({
  open: initial,
  menuId: '',

  subLevelOpen: false,
  subLevelMenuId: '',

  /**
   * Open the 1st-level menu.
   */
  openFirstLevelMenu(): void {
    this.open = true;
  },

  /**
   * Toggle the 1st-level menu.
   *
   * @param menuId - the menu Id
   */
  toggleMenu(menuId: string): void {
    const isEqual = this.menuId === menuId;

    if (!isEqual || menuId === '') {
      this.menuId = menuId;
      this.open = true;
      this.$dispatch('change-menu');
    } else {
      this.closeFirstLevelMenu();
    }
  },

  /**
   * Close the 1st-level menu (and sub-menu for mobile).
   */
  closeFirstLevelMenu(): void {
    this.open = false;
    this.menuId = '';

    this.closeSubLevelMenu();
  },

  /**
   * Indicates if the 1st-level menu is opened.
   *
   * @returns boolean
   */
  isFirstLevelOpen(): boolean {
    return this.open;
  },

  /**
   * Indicates if the 1st-level menu is opened with the given menu Id.
   *
   * @param menuId - The menu Id
   *
   * @returns boolean
   */
  isFirstLevelMenuOpen(menuId: string): boolean {
    return this.open && this.menuId === menuId;
  },

  /**
   * Open the sub-menu based on the given menu Id (mobile only).
   *
   * @param subMenuId - The sub-menu Id
   */
  openSubLevelMenu(subMenuId: string): void {
    this.subLevelOpen = true;
    this.subLevelMenuId = subMenuId;
  },

  /**
   * Close the sub-menu (mobile only).
   */
  closeSubLevelMenu(): void {
    this.subLevelOpen = false;
    this.subLevelMenuId = '';
  },

  /**
   * Indicates if the sub-menu is open.
   *
   * @returns boolean
   */
  isSubLevelOpen(): boolean {
    return this.subLevelOpen;
  },

  /**
   * Indicates if the sub-menu is opened with the given menu Id.
   *
   * @param subMenuId - The sub-menu Id
   *
   * @returns boolean
   */
  isSubLevelMenuOpen(subMenuId: string): boolean {
    return this.subLevelOpen && this.subLevelMenuId === subMenuId;
  },
});

export default FirstLevelMenu;
